<template>
  <div class="form-group">
    <label :for="fieldId">{{ label }}<span v-if="required">*</span></label>

    <input
      v-if="component === 'input'"
      :id="fieldId"
      v-model="internalValue"
      :type="type"
      :step="type === 'number' ? step : undefined"
      :disabled="disabled"
      :required="required"
      @keydown.enter.prevent
      @blur="handleBlur"
    />

    <HiloSelect
      v-if="component === 'select'"
      :id="fieldId"
      :options="options"
      placeholder=""
      v-model="internalValue"
      :disabled="disabled"
      :required="required"
      @change="emitChange"
    />

    <textarea
      v-if="component === 'textarea'"
      :id="fieldId"
      v-model="internalValue"
      :disabled="disabled"
      :required="required"
      @keydown.enter.prevent
      @blur="handleBlur"
    />

    <HiloButton
      v-if="component === 'button'"
      :id="fieldId"
      :label="buttonLabel"
      :disabled="disabled"
      @click="handleButtonClick"
    />
  </div>
</template>

<script>
import HiloButton from "../../../../components/HiloComponents/HiloButton.vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";

export default {
  components: { HiloSelect, HiloButton },
  props: {
    label: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
    component: {
      type: String,
      default: "input",
    },
    type: {
      type: String,
      default: "text",
    },
    step: {
      type: [String, Number],
      default: "any",
    },
    options: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: "Click Me",
    },
  },
  data() {
    return {
      internalValue: this.value !== null ? this.value : "",
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal !== null ? newVal : "";
    },
    internalValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    handleButtonClick() {
      this.$emit("button-click");
    },
    emitChange() {
      this.$emit("change", this.internalValue);
    },
    handleBlur() {
      if (typeof this.internalValue === "string") {
        this.internalValue = this.internalValue.trim();
      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input,
.form-group textarea,
.form-group select,
.form-group button {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  height: 32px;
  box-sizing: border-box;
}

.form-group textarea {
  padding: 4px 8px;
}
</style>
